
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tradelaw",
      function () {
        return require("private-next-pages/tradelaw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tradelaw"])
      });
    }
  